/**
 * Header: Desktop Mega Menu + Mobile Drawer
 */
(function () {
    'use strict';

    /* ======================================================================
     * Desktop Mega Menu
     * ====================================================================== */
    function initDesktopMegaMenu() {
        var navItems = document.querySelectorAll('[data-megamenu-trigger]');
        var panels = document.querySelectorAll('[data-megamenu-panel]');
        var closeTimeout = null;

        function openPanel(handle) {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = null;
            }

            panels.forEach(function (panel) {
                panel.classList.remove('megamenu--active');
                panel.setAttribute('aria-hidden', 'true');
            });
            navItems.forEach(function (item) {
                item.classList.remove('header__nav-item--hover');
            });

            var panel = document.querySelector('[data-megamenu-panel="' + handle + '"]');
            var navItem = document.querySelector('[data-megamenu-trigger="' + handle + '"]');

            if (panel) {
                panel.classList.add('megamenu--active');
                panel.setAttribute('aria-hidden', 'false');
            }
            if (navItem) {
                navItem.classList.add('header__nav-item--hover');
            }
        }

        function closeAllPanels() {
            closeTimeout = setTimeout(function () {
                panels.forEach(function (panel) {
                    panel.classList.remove('megamenu--active');
                    panel.setAttribute('aria-hidden', 'true');
                });
                navItems.forEach(function (item) {
                    item.classList.remove('header__nav-item--hover');
                });
            }, 150);
        }

        function cancelClose() {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = null;
            }
        }

        navItems.forEach(function (item) {
            var handle = item.getAttribute('data-megamenu-trigger');
            if (!handle) return;

            item.addEventListener('mouseenter', function () {
                openPanel(handle);
            });
            item.addEventListener('mouseleave', closeAllPanels);
        });

        panels.forEach(function (panel) {
            panel.addEventListener('mouseenter', cancelClose);
            panel.addEventListener('mouseleave', closeAllPanels);
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                cancelClose();
                panels.forEach(function (panel) {
                    panel.classList.remove('megamenu--active');
                    panel.setAttribute('aria-hidden', 'true');
                });
                navItems.forEach(function (item) {
                    item.classList.remove('header__nav-item--hover');
                });
            }
        });
    }

    /* ======================================================================
     * Mobile Menu (Drawer + Tabs)
     * ====================================================================== */
    function initMobileMenu() {
        var mobileMenu = document.querySelector('[data-mobile-menu]');
        if (!mobileMenu) return;

        var toggleButtons = document.querySelectorAll('[data-mobile-menu-toggle]');
        var overlays = document.querySelectorAll('[data-mobile-menu-close]');
        var tabs = document.querySelectorAll('[data-mobile-tab]');
        var contentPanels = document.querySelectorAll('[data-mobile-content]');

        function openDrawer() {
            mobileMenu.classList.add('mobile-menu--open');
            mobileMenu.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
        }

        function closeDrawer() {
            mobileMenu.classList.remove('mobile-menu--open');
            mobileMenu.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }

        function toggleDrawer() {
            if (mobileMenu.classList.contains('mobile-menu--open')) {
                closeDrawer();
            } else {
                openDrawer();
            }
        }

        toggleButtons.forEach(function (btn) {
            btn.addEventListener('click', toggleDrawer);
        });

        overlays.forEach(function (el) {
            el.addEventListener('click', closeDrawer);
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('mobile-menu--open')) {
                closeDrawer();
            }
        });

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var handle = tab.getAttribute('data-mobile-tab');

                tabs.forEach(function (t) {
                    t.classList.remove('mobile-menu__tab--active');
                    t.setAttribute('aria-selected', 'false');
                });
                contentPanels.forEach(function (p) {
                    p.classList.remove('mobile-menu__content--active');
                });

                tab.classList.add('mobile-menu__tab--active');
                tab.setAttribute('aria-selected', 'true');

                var panel = document.querySelector('[data-mobile-content="' + handle + '"]');
                if (panel) {
                    panel.classList.add('mobile-menu__content--active');
                }
            });
        });

        // Accordion label: navigate without toggling the disclosure.
        // The <a> sits inside <summary>, so clicks would normally toggle <details>.
        // We let the link navigate but stop the toggle event from reaching <summary>.
        mobileMenu.querySelectorAll('.mobile-menu__accordion-trigger .mobile-menu__accordion-label').forEach(function (label) {
            label.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    }

    /* ======================================================================
     * Init
     * ====================================================================== */
    function setHeaderHeight() {
        // Measure the bottom edge of .section-header in viewport coords so
        // the mobile drawer accounts for any sticky promo bar above it.
        var sectionHeader = document.querySelector('.section-header');
        if (sectionHeader) {
            var rect = sectionHeader.getBoundingClientRect();
            var height = Math.max(rect.bottom, sectionHeader.offsetHeight);
            document.documentElement.style.setProperty('--header-height', height + 'px');
            return;
        }
        var header = document.querySelector('[data-header]');
        if (header) {
            document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        setHeaderHeight();
        initDesktopMegaMenu();
        initMobileMenu();
    });
    window.addEventListener('resize', setHeaderHeight);
})();
